import React from 'react'
import PropTypes from 'prop-types';
import PurchasingGroupList from "./PurchasingGroupList";

function PurchasingGroupMemberList(
    {
        match
    }
) {
    return <PurchasingGroupList match={match} member/>
}

PurchasingGroupMemberList.propTypes = {
    classes: PropTypes.any,
}

export default PurchasingGroupMemberList;